/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import {
  orderSubmitNotification,
  cancelOrder,
  updateOrderStatus,
  updateSavedOrderData,
  saveArtFiles,
  downloadArtFile,
  getPaypalTransactionId,
  generateArtboard,
  marketPlaceOrderDetails,
} from "actions/orders";
import { login } from "actions/auth";
import { getAllProducts } from "actions/products";
import { useHistory } from "react-router-dom";
import {
  isSub,
  getDesignerSettingsFromProductId,
  getAdditionalTechniquesFromProductId,
} from "selectors/products";
import Dialog from "@material-ui/core/Dialog";
import Button from "components/Button";
import Slider from "react-slick";
import OrderSubmitToProd from "pages/warehouse/OrderSubmitToProd";
import UpdateOrderTracking from "pages/warehouse/UpdateOrderTracking";
import BrowseLibrary from "components/ArtWork/BrowseLibrary";
import PrintOrderSummaryModal from "pages/warehouse/PrintOrderSummaryModal";
import {
  Container,
  Wrapper,
  OrderPreview,
  OrderDetail,
  OrderSummary,
  ProductOverview,
  ImagePreview,
  Details,
  OrderPushedButton,
  SendInvoice,
  CancelOrder,
  PrintAreasSlider,
  Personalized,
} from "styles/pages/warehouse/orderModal";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const OrderModal = ({
  modal,
  setModal,
  order: orderData,
  openModalPayment,
  pushOrderToMachine,
  user,
  sendOrderToPlant,
}) => {
  const [order, setOrder] = useState(orderData);
  const auth = useSelector((state) => state?.auth);
  const products = useSelector((state) => state?.products?.data);
  const [orderSubmitToProdModal, setOrderSubmitToProd] = useState(undefined);
  const [printOrderSummaryModal, setPrintOrderSummaryModal] =
    useState(undefined);
  const [orderTrackingModal, setOrderTrackingModal] = useState(undefined);
  const orderLineItems = order?.ShirtlyOrderData?.OrderLines[0]?.OrderLineItems;
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const printProvider = order?.ShirtlyOrderData?.PrintProvider;
  const [browseLibrary, setBrowseLibrary] = useState(false);
  const [paypalTransactionId, setPaypalTransactionId] = useState(null);
  const isSam =
    order?.ShirtlyOrderData?.MasterUserEmail === "sam@bemerchful.com";

  const dispatch = useDispatch();
  const history = useHistory();

  const isAU = order?.ShirtlyOrderData?.PrintProvider === "AU";
  const isEU = order?.ShirtlyOrderData?.PrintProvider === "EU";

  useEffect(async () => {
    if (order?.PaypalChargeInfo) {
      const response = await dispatch(
        getPaypalTransactionId({
          orderId: order?.PaypalChargeInfo?.id,
        })
      );
      if (response?.error) {
        return;
      }
      setPaypalTransactionId(
        response?.purchase_units[0]?.payments?.captures[0]?.id
      );
    }
  }, [order, setPaypalTransactionId]);

  useEffect(async () => {
    if (isSam && order) {
      let orderClone = _.clone(order);
      const { OrderLines: orderLines } = orderClone?.ShirtlyOrderData;
      const { OrderLineItems: orderLineItems } = orderLines?.length
        ? orderLines[0]
        : [];

      for (let i = 0; i < orderLineItems.length; i++) {
        const lineItem = orderLineItems[i];

        const payload = {
          user: "sam@bemerchful.com",
          marketPlace: orderClone?.ShirtlyOrderData?.Marketplace,
          lineItemArrId: lineItem?.ID,
          productId: lineItem?.StoreProductID,
          shopName: orderClone?.ShirtlyOrderData?.Store?.ShopName,
          details: lineItem?.Details,
          ListingID: orderLines[0]?.ListingID,
        };
        const response = await dispatch(marketPlaceOrderDetails(payload));
        lineItem.MockupSrc = response?.imgSrc;
      }
      setOrder(() => orderClone);
    }
  }, []);

  return (
    <Dialog maxWidth="xl" open={modal} onClose={() => setModal(false)}>
      <Container>
        <Wrapper>
          {order?._id ? (
            <OrderPreview>
              <h1>Order {order?.ShirtlyOrderData?.ReceiptID}</h1>
              <h4>Products in this order</h4>

              <ProductOverview>
                <Slider {...settings}>
                  {orderLineItems?.map((orderLine, index) => {
                    const isProductSub = isSub(products, orderLine?.ProductID);
                    let designerSettings = getDesignerSettingsFromProductId(
                      products,
                      orderLine?.ProductID
                    );

                    const printType = orderLine?.PrintType;
                    const printAreas = orderLine?.printAreas;
                    const printAreasUploaded = printAreas?.filter(
                      (p) => p?.MockupSrc
                    );

                    const marketPlaceDetails = orderLine?.MarketPlaceDetails;
                    const properties = marketPlaceDetails?.properties;

                    const isPersonlised = properties?.find(
                      (p) => p?.name === "Personalized"
                    );

                    if (printType !== "DTG") {
                      designerSettings =
                        getAdditionalTechniquesFromProductId(
                          products,
                          orderLine?.ProductID,
                          false,
                          printType
                        ) || designerSettings;
                    }

                    const width = Math.round(
                      orderLine?.ArtWorkCoordinates?.width *
                        (designerSettings?.multiplier || 16)
                    );
                    const height = Math.round(
                      orderLine?.ArtWorkCoordinates?.height *
                        (designerSettings?.multiplier || 16)
                    );

                    const artworkImageSplit =
                      orderLine?.Artwork?.split("/upload/");

                    const artWorkImage = artworkImageSplit
                      ? `${artworkImageSplit[0]}/upload/w_${width},h_${height}/${artworkImageSplit[1]}`
                      : "";

                    const widthInInch =
                      orderLine?.ArtWorkCoordinates?.width >=
                      designerSettings?.width
                        ? designerSettings?.platenWidthInch
                        : (
                            (orderLine?.ArtWorkCoordinates?.width ||
                              0 * (designerSettings?.multiplier || 16)) / 255
                          ).toFixed(1);

                    const heightInInch =
                      orderLine?.ArtWorkCoordinates?.height >=
                      designerSettings?.height
                        ? designerSettings?.platenHeightInch
                        : (
                            (orderLine?.ArtWorkCoordinates?.height ||
                              0 * (designerSettings?.multiplier || 16)) / 255
                          ).toFixed(1);

                    const backWidthInInch =
                      orderLine?.BackArtWorkCoordinates?.width >=
                      designerSettings?.width
                        ? designerSettings?.platenWidthInch
                        : (
                            (orderLine?.BackArtWorkCoordinates?.width *
                              (designerSettings?.multiplier || 16)) /
                            255
                          ).toFixed(1);

                    const backHeightInInch =
                      orderLine?.BackArtWorkCoordinates?.height >=
                      designerSettings?.height
                        ? designerSettings?.platenHeightInch
                        : (
                            (orderLine?.BackArtWorkCoordinates?.height *
                              (designerSettings?.multiplier || 16)) /
                            255
                          ).toFixed(1);

                    let duraSoftArtWork = null;
                    let duraSoftBackArtWork = null;

                    if (orderLine?.PrintType === "DURASOFT") {
                      const artworkImageSplit =
                        orderLine?.Artwork?.split("/upload/");

                      if (artworkImageSplit) {
                        duraSoftArtWork = `${
                          artworkImageSplit[0]
                        }/upload/w_${parseInt(
                          orderLine?.ArtWorkCoordinates?.width *
                            (designerSettings?.multiplier || 16)
                        )},h_${parseInt(
                          orderLine?.ArtWorkCoordinates?.height *
                            (designerSettings?.multiplier || 16)
                        )}/${artworkImageSplit[1]}`;
                      }

                      if (orderLine?.BackArtwork) {
                        const artworkBackImageSplit =
                          orderLine?.BackArtwork?.split("/upload/");

                        duraSoftBackArtWork = `${
                          artworkBackImageSplit[0]
                        }/upload/w_${parseInt(
                          orderLine?.BackArtWorkCoordinates?.width *
                            (designerSettings?.multiplier || 16)
                        )},h_${parseInt(
                          orderLine?.BackArtWorkCoordinates?.height *
                            (designerSettings?.multiplier || 16)
                        )}/${artworkBackImageSplit[1]}`;
                      }
                    }

                    return (
                      <PrintAreasSlider key={`orderLine${index}`}>
                        {printAreasUploaded?.length > 0 ? (
                          <Slider
                            {...settings}
                            dots={false}
                            arrows={true}
                            swipeToSlide={false}
                            infinite={false}
                          >
                            {isSam ? (
                              <ImagePreview>
                                {!!isPersonlised && (
                                  <Personalized>
                                    Personalized : {isPersonlised?.value}
                                    &nbsp; (RIGHT CHEST)
                                  </Personalized>
                                )}
                                <img
                                  src={orderLine?.MockupSrc}
                                  alt="ProductImage"
                                />
                              </ImagePreview>
                            ) : (
                              printAreasUploaded?.map((p) =>
                                p?.MockupSrc ? (
                                  <ImagePreview>
                                    {!!isPersonlised && (
                                      <Personalized>
                                        Personalized : {isPersonlised?.value}
                                        &nbsp; (RIGHT CHEST)
                                      </Personalized>
                                    )}
                                    <img
                                      src={p?.MockupSrc}
                                      alt="ProductImage"
                                    />
                                  </ImagePreview>
                                ) : null
                              )
                            )}
                          </Slider>
                        ) : (
                          <>
                            {!!isPersonlised && (
                              <Personalized>
                                Personalized : {isPersonlised?.value}
                                &nbsp; (RIGHT CHEST)
                              </Personalized>
                            )}
                            <ImagePreview>
                              <img
                                src={
                                  orderLine?.MockupSrc ||
                                  orderLine?.MarketingImagePath
                                }
                                alt="ProductImage"
                              />
                              {orderLine?.MockupBackSrc && (
                                <img
                                  src={orderLine?.MockupBackSrc}
                                  alt="ProductImage"
                                />
                              )}
                            </ImagePreview>
                          </>
                        )}

                        <Details>
                          <div>
                            <h4>
                              Product&nbsp;:&nbsp;
                              <span>
                                {isSam
                                  ? marketPlaceDetails?.name
                                  : orderLine?.Product}
                              </span>
                            </h4>
                            <h4>
                              Fulfillment Cost&nbsp;:&nbsp;
                              <span>${orderLine?.FulfillmentCost}</span>
                            </h4>
                          </div>

                          <div>
                            <h4>
                              Quantity&nbsp;:&nbsp;
                              <span>{orderLine?.OliQuantity}</span>
                            </h4>
                            <h4>
                              Category&nbsp;:&nbsp;
                              <span>{orderLine?.Category}</span>
                            </h4>
                          </div>

                          <div>
                            <h4>
                              Print Provider&nbsp;:&nbsp;
                              <span>
                                {order?.ShirtlyOrderData?.PrintProvider}
                              </span>
                            </h4>
                            <h4>
                              Status&nbsp;:&nbsp;
                              <span>{order?.ShirtlyOrderData?.Status}</span>
                            </h4>
                          </div>

                          <div>
                            <h4
                              style={{
                                border:
                                  isSam && !!isPersonlised
                                    ? "1px solid red"
                                    : "inherit",
                              }}
                            >
                              Size&nbsp;:&nbsp;
                              <span>
                                {isSam
                                  ? marketPlaceDetails?.variant_title
                                  : orderLine?.Size}
                              </span>
                            </h4>
                            <h4
                              style={{
                                border:
                                  isSam && !!isPersonlised
                                    ? "1px solid red"
                                    : "inherit",
                              }}
                            >
                              Color&nbsp;:&nbsp;
                              <span>
                                {isSam
                                  ? marketPlaceDetails?.variant_title
                                  : orderLine?.Color}
                              </span>
                            </h4>
                            <h4>
                              Item ID&nbsp;:&nbsp;
                              <span>{orderLine?.OrderLineID}</span>
                            </h4>

                            <h4>
                              Date Created&nbsp;:&nbsp;
                              <span>
                                {order?.ShirtlyOrderData?.DateCreated}
                              </span>
                            </h4>

                            {order?.OrderSubmitToProductionDate && (
                              <h4>
                                Production Date&nbsp;:&nbsp;
                                <span>
                                  {order?.OrderSubmitToProductionDate}
                                </span>
                              </h4>
                            )}
                            {order?.ShirtlyOrderData?.PickUp && (
                              <h4>
                                Order Type&nbsp;:&nbsp;
                                <span>Pick Up</span>
                              </h4>
                            )}

                            {order?.OrderShippedDate && (
                              <h4>
                                Shipped Date&nbsp;:&nbsp;
                                <span>{order?.OrderShippedDate}</span>
                              </h4>
                            )}
                          </div>
                          {orderLine?.PrintType && (
                            <div>
                              <h4>
                                Print Type&nbsp;:&nbsp;
                                <span>{orderLine?.PrintType}</span>
                              </h4>

                              {!printAreasUploaded?.length && (
                                <h4>
                                  Art Dimensions&nbsp;:&nbsp;
                                  <span>
                                    {widthInInch} X {heightInInch} inches
                                  </span>
                                </h4>
                              )}

                              {printAreasUploaded?.length > 0 &&
                                printAreasUploaded?.map((p) => {
                                  const {
                                    coordinates,
                                    designerSettings,
                                    printAreaName,
                                  } = p;
                                  const { width, height } = coordinates;
                                  const { multiplier } = designerSettings;

                                  const widthInInch =
                                    width >= designerSettings?.width
                                      ? designerSettings?.platenWidthInch
                                      : (
                                          (width * (multiplier || 16)) /
                                          255
                                        ).toFixed(1);

                                  const heightInInch =
                                    height >= designerSettings?.height
                                      ? designerSettings?.platenHeightInch
                                      : (
                                          (height * (multiplier || 16)) /
                                          255
                                        ).toFixed(1);

                                  return (
                                    <h4>
                                      {printAreaName} Art
                                      Dimensions&nbsp;:&nbsp;
                                      <span>
                                        {widthInInch} X {heightInInch} inches
                                      </span>
                                    </h4>
                                  );
                                })}
                            </div>
                          )}

                          {!!isPersonlised && (
                            <h4>
                              RIGHT CHEST ARTWORK&nbsp;:&nbsp;
                              <span>{isPersonlised?.value}</span>
                            </h4>
                          )}
                          {!!orderLine?.ArtworkId && (
                            <h4>
                              Order Artwork ID&nbsp;:&nbsp;
                              <span>{orderLine?.ArtworkId}</span>
                            </h4>
                          )}
                          <div>
                            {!printAreasUploaded?.length && (
                              <h4>
                                Download&nbsp;
                                {orderLine?.aopVectorFile
                                  ? "AOP Vector File"
                                  : "Artwork"}
                                &nbsp;:&nbsp;
                                <span>
                                  {duraSoftArtWork ? (
                                    <a
                                      href={duraSoftArtWork}
                                      download
                                      target="_blank"
                                    >
                                      Download
                                    </a>
                                  ) : (
                                    <a
                                      href={
                                        orderLine?.Artwork ||
                                        orderLine?.aopVectorFile
                                      }
                                      download
                                      target="_blank"
                                    >
                                      Download
                                    </a>
                                  )}
                                </span>
                              </h4>
                            )}

                            {printAreasUploaded?.length > 0 &&
                              printAreasUploaded?.map((p) => {
                                const { printAreaName, artwork } = p;

                                return (
                                  <h4>
                                    Download&nbsp;
                                    {printAreaName}&nbsp;Artwork &nbsp;:&nbsp;
                                    <span>
                                      <a
                                        href={artwork}
                                        download
                                        target="_blank"
                                      >
                                        Download
                                      </a>
                                    </span>
                                  </h4>
                                );
                              })}
                            <h4>
                              <Button
                                title="Download Art File"
                                containerStyle={{
                                  marginLeft: 20,
                                  background: "white",
                                  boxShadow: "none",
                                  padding: 0,
                                  textDecoration: "underline",
                                  float: "right",
                                  fontSize: 12,
                                  textTransform: "none",
                                  fontWeight: " bold",
                                }}
                                onClick={async () => {
                                  const payload = {
                                    emailid:
                                      order?.ShirtlyOrderData?.MasterUserEmail,
                                    id: orderLine?.ArtworkId,
                                  };
                                  const response = await dispatch(
                                    downloadArtFile(payload)
                                  );

                                  if (response?.uploadInfo) {
                                    window.open(
                                      response?.uploadInfo?.secure_url
                                    );
                                  } else {
                                    alert("No ArtFile saved for this product");
                                  }
                                }}
                              />
                              <Button
                                title="Upload Art File"
                                containerStyle={{
                                  marginLeft: 20,
                                  background: "white",
                                  boxShadow: "none",
                                  padding: 0,
                                  textDecoration: "underline",
                                  float: "right",
                                  fontSize: 12,
                                  textTransform: "none",
                                  fontWeight: " bold",
                                }}
                                onClick={async () => {
                                  const myWidget =
                                    window.cloudinary.createUploadWidget(
                                      {
                                        cloudName: "big-oven-tees-inc",
                                        uploadPreset: "tnedst8q",
                                        folder: `BOTApp/${order?.ShirtlyOrderData?.MasterUserEmail}/SavedFiles`,
                                      },
                                      async (error, result) => {
                                        if (
                                          !error &&
                                          result &&
                                          result.event === "success"
                                        ) {
                                          const payload = {
                                            emailid:
                                              order?.ShirtlyOrderData
                                                ?.MasterUserEmail,
                                            saveData: {
                                              uploadInfo: result?.info,
                                              id: orderLine?.ArtworkId,
                                            },
                                          };

                                          await dispatch(saveArtFiles(payload));
                                          myWidget.close();
                                        }
                                      }
                                    );
                                  myWidget.open();
                                }}
                              />
                            </h4>
                          </div>

                          {orderLine?.BackArtwork &&
                            !printAreasUploaded?.length && (
                              <div style={{ gridTemplateColumns: "1fr 1fr" }}>
                                <h4>
                                  Download <br />
                                  Back Artwork&nbsp;:&nbsp;
                                  <span>
                                    <a
                                      href={
                                        duraSoftBackArtWork
                                          ? duraSoftBackArtWork
                                          : orderLine?.BackArtwork
                                      }
                                      download
                                      target="_blank"
                                    >
                                      Download
                                    </a>
                                  </span>
                                </h4>
                                <h4>
                                  Art Dimensions&nbsp;:&nbsp;
                                  <span>
                                    {backWidthInInch} X {backHeightInInch}&nbsp;
                                    inches
                                  </span>
                                </h4>
                              </div>
                            )}

                          {isProductSub && (
                            <div
                              style={{
                                gridTemplateColumns: "1fr",
                              }}
                            >
                              <h4>
                                Download Sublimation File&nbsp;:&nbsp;
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={async () => {
                                    const designerSettings =
                                      getDesignerSettingsFromProductId(
                                        products,
                                        orderLine?.ProductID
                                      );

                                    const payload = {
                                      user: emailid,
                                      artBoard: orderLine?.MarketingImageBase64,
                                      artWorkImage: artWorkImage.replaceAll(
                                        "co_rgb:aaa9ad",
                                        "co_rgb:000000"
                                      ),
                                      artCord: {
                                        x:
                                          orderLine?.ArtWorkCoordinates?.x *
                                          designerSettings?.multiplier,
                                        y:
                                          orderLine?.ArtWorkCoordinates?.y *
                                          designerSettings?.multiplier,
                                      },
                                    };

                                    const url = await dispatch(
                                      generateArtboard(payload)
                                    );

                                    window.open(url);
                                  }}
                                >
                                  Download
                                </span>
                              </h4>
                            </div>
                          )}
                        </Details>

                        {orderLine?.DtgPlus && (
                          <Details>
                            <div>
                              <h4>
                                DTG Plus Process Name&nbsp;:&nbsp;
                                <span>
                                  {orderLine?.DtgPlus?.DtgPlusProcess}
                                </span>
                              </h4>
                              <h4>
                                DTG Plus Process Color&nbsp;:&nbsp;
                                <span>
                                  {orderLine?.DtgPlus?.DtgPlusProcessColor}
                                </span>
                              </h4>
                            </div>

                            <div>
                              <h4>
                                Download Vector File&nbsp;:&nbsp;
                                <span>
                                  <a
                                    href={orderLine?.DtgPlus?.DtgPlusVectorFile}
                                    download
                                    target="_blank"
                                  >
                                    Download
                                  </a>
                                </span>
                              </h4>
                              <h4>
                                Download Mock File&nbsp;:&nbsp;
                                <span>
                                  <a
                                    href={orderLine?.DtgPlus?.dtgPlusMockFile}
                                    download
                                    target="_blank"
                                  >
                                    Download
                                  </a>
                                </span>
                              </h4>
                            </div>
                            <div>
                              <div>
                                <img
                                  style={{ width: 200, margin: "20px auto" }}
                                  src={
                                    orderLine?.DtgPlus?.DtgPlusProcessColorImage
                                  }
                                  alt="dtg plus color file"
                                />
                                <div style={{ textAlign: "center" }}>
                                  Selected DTG Plus Color{" "}
                                  <b>
                                    ({orderLine?.DtgPlus?.DtgPlusProcessColor})
                                  </b>
                                </div>
                              </div>
                              <div>
                                <img
                                  style={{ width: 200, margin: "20px auto" }}
                                  src={orderLine?.DtgPlus?.dtgPlusMockFile}
                                  alt="dtg plus mock file"
                                />
                                <div style={{ textAlign: "center" }}>
                                  Selected DTG Plus Mock File
                                </div>
                              </div>
                            </div>
                          </Details>
                        )}
                      </PrintAreasSlider>
                    );
                  })}
                </Slider>
              </ProductOverview>
              <Button
                onClick={() => setBrowseLibrary(true)}
                title="User Art Library"
                containerStyle={{
                  width: "100%",
                  border: "1px solid #2379b4",
                  color: "#2379b4",
                  backgroundColor: "transparent",
                  fontWeight: "bold",
                  margin: "10px 0",
                }}
              />
            </OrderPreview>
          ) : (
            <OrderPreview>
              <h3>
                Due to some network error, Order is not pushed to production.
              </h3>
            </OrderPreview>
          )}
          {order?._id ? (
            <div>
              <OrderDetail>
                <h2>Order Details</h2>
                <h4>
                  Buyer Name:&nbsp;
                  <span>{order?.ShirtlyOrderData?.BuyerName}</span>
                </h4>

                <h4>
                  Address Line One:&nbsp;
                  <span>{order?.ShirtlyOrderData?.AddressLineOne}</span>
                  {order?.ShirtlyOrderData?.AddressLineTwo && (
                    <span>&nbsp;{order?.ShirtlyOrderData?.AddressLineTwo}</span>
                  )}
                  <span>,&nbsp;{order?.ShirtlyOrderData?.City},</span>
                  <span>&nbsp;{order?.ShirtlyOrderData?.StateProvince}</span>
                  <span>&nbsp;{order?.ShirtlyOrderData?.ZipPostal},</span>
                  <span>&nbsp;{order?.ShirtlyOrderData?.CountryString}</span>
                </h4>
              </OrderDetail>
              <OrderSummary>
                <h2>Order Summary</h2>
                {order?.ShirtlyOrderData?.Status == "Shipped" && (
                  <h4>
                    Tracking Number:&nbsp;
                    <span>
                      <a
                        rel="noreferrer"
                        href={
                          isAU
                            ? order?.DataForMachine?.events?.find(
                                (e) => e?.action === "shipped"
                              )?.trackingUrl
                            : order?.ShirtlyOrderData?.PrintProvider == "CA"
                            ? `https://www.canadapost.ca/track-reperage/en#/details/${order?.ShirtlyOrderData?.TrackingNumber}`
                            : `https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=${order?.ShirtlyOrderData?.TrackingNumber}`
                        }
                        target="_blank"
                      >
                        {order?.ShirtlyOrderData?.TrackingNumber}
                      </a>
                    </span>
                  </h4>
                )}
                <h4>
                  User Email:&nbsp;
                  <span>{order?.ShirtlyOrderData?.MasterUserEmail}</span>
                  <span
                    style={{
                      float: "right",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={async () => {
                      const request = await dispatch(
                        login({
                          email: user?.email,
                          password: user?.password,
                        })
                      );
                      if (request?.error) {
                        return;
                      }

                      await dispatch(getAllProducts(auth));
                      history.replace("/");
                    }}
                  >
                    Impersonate
                  </span>
                </h4>
                <h4>
                  Shipping:&nbsp;
                  <span>
                    ${order?.ShirtlyOrderData?.TotalCostForShipping}&nbsp;USD
                  </span>
                </h4>
                <h4>
                  Total:&nbsp;
                  {order?.StripeChargeInfo && (
                    <span>
                      {order?.StripeChargeInfo?.amount ? (
                        `$${order?.StripeChargeInfo?.amount / 100}`
                      ) : openModalPayment ? (
                        <span className="access-button">
                          Payment failed
                          <Button
                            title="Access Payment"
                            containerStyle={{
                              marginLeft: 20,
                              background: "white",
                              boxShadow: "none",
                              padding: 0,
                              textDecoration: "underline",
                              float: "right",
                              fontSize: 10,
                              textTransform: "none",
                              fontWeight: " bold",
                            }}
                            onClick={openModalPayment}
                          />
                        </span>
                      ) : null}
                      &nbsp;
                      {order?.StripeChargeInfo?.currency?.toUpperCase()}
                    </span>
                  )}
                  {order?.PaypalChargeInfo && (
                    <span>
                      {order?.PaypalChargeInfo?.purchase_units[0]?.amount
                        .value ? (
                        `$${order?.PaypalChargeInfo?.purchase_units[0]?.amount.value} USD`
                      ) : openModalPayment ? (
                        <span className="access-button">
                          Payment failed
                          <Button
                            title="Access Payment"
                            containerStyle={{
                              marginLeft: 20,
                              background: "white",
                              boxShadow: "none",
                              padding: 0,
                              textDecoration: "underline",
                              float: "right",
                              fontSize: 10,
                              textTransform: "none",
                              fontWeight: " bold",
                            }}
                            onClick={openModalPayment}
                          />
                        </span>
                      ) : null}
                    </span>
                  )}
                  {!order?.PaypalChargeInfo && !order?.StripeChargeInfo && (
                    <span className="access-button">
                      Payment failed
                      <Button
                        title="Access Payment"
                        containerStyle={{
                          marginLeft: 20,
                          background: "white",
                          boxShadow: "none",
                          padding: 0,
                          textDecoration: "underline",
                          float: "right",
                          fontSize: 10,
                          textTransform: "none",
                          fontWeight: " bold",
                        }}
                        onClick={openModalPayment}
                      />
                    </span>
                  )}
                </h4>
                {(order?.StripeChargeInfo?.id || paypalTransactionId) && (
                  <h4>
                    Transaction Id:&nbsp;
                    <span>
                      {order?.StripeChargeInfo?.id || paypalTransactionId}
                    </span>
                  </h4>
                )}
                {(order?.StripeChargeInfo || order?.PaypalChargeInfo) && (
                  <h4>
                    Payment Method:&nbsp;
                    <span>{order?.StripeChargeInfo ? "Stripe" : "Paypal"}</span>
                    {order?.StripeChargeInfo?.status === "succeeded" && (
                      <span>
                        &nbsp;
                        <a
                          href={order?.StripeChargeInfo?.receipt_url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          (Receipt)
                        </a>
                      </span>
                    )}
                  </h4>
                )}

                {!isEU &&
                  !isAU &&
                  !order?.isOrderPushedToMachine &&
                  pushOrderToMachine && (
                    <OrderPushedButton onClick={pushOrderToMachine}>
                      Push Order To Machine
                    </OrderPushedButton>
                  )}

                {order?.ShirtlyOrderData?.Status !== "Cancelled" && (
                  <CancelOrder
                    style={{ marginRight: 10 }}
                    onClick={async () => {
                      const payload = {
                        orderId: order?.ShirtlyOrderData?.ReceiptID,
                        printProvider: order?.ShirtlyOrderData?.PrintProvider,
                        source: order?.ShirtlyOrderData?.PickUp
                          ? "Admin_PickUp"
                          : undefined,
                      };
                      const response = await dispatch(cancelOrder(payload));
                      if (
                        !response?.DeleteOrderResponse?.DeleteOrderResult
                          ?.ErrorMessage?._text
                      ) {
                        await dispatch(
                          updateOrderStatus({
                            user: order?.ShirtlyOrderData?.MasterUserEmail,
                            orderId: order?.ShirtlyOrderData?.ID,
                            status: "Cancelled",
                          })
                        );

                        await dispatch(
                          updateSavedOrderData({
                            orderId: order?.ShirtlyOrderData?.ID,
                            status: "Cancelled",
                          })
                        );
                        setModal(false);
                      }
                    }}
                  >
                    Cancel Order
                  </CancelOrder>
                )}
                <SendInvoice
                  onClick={async () => {
                    const { OrderLines } = order?.ShirtlyOrderData;
                    let fulfillmentCost = 0;

                    if (OrderLines?.length) {
                      const { OrderLineItems } = OrderLines[0];

                      for (let i = 0; i < OrderLineItems?.length; i++) {
                        fulfillmentCost += OrderLineItems[i]?.FulfillmentCost;
                      }
                    }

                    const totalInUsd = Number(
                      order?.grandTotalInUsd ||
                        order?.ShirtlyOrderData?.grandTotalInUSD
                    );

                    const shippingCost = Number(
                      order?.finalShippingCost ||
                        order?.ShirtlyOrderData?.ShippingCost
                    );

                    const finalFulfillmentCost = Number(
                      order?.fulfillmentCost || fulfillmentCost
                    );

                    await dispatch(
                      orderSubmitNotification({
                        orderData: order?.ShirtlyOrderData,
                        finalShippingCost: shippingCost,
                        fulfillmentCost: finalFulfillmentCost,
                        grandTotalInCan: Number(
                          order?.grandTotalInCan ||
                            order?.ShirtlyOrderData?.grandTotalInCAD
                        ),
                        grandTotalInUsd: totalInUsd,
                        shippingWithoutTax: Number(
                          order?.shippingWithoutTax ||
                            order?.ShirtlyOrderData?.ShippingCost
                        ),
                        totalTax:
                          order?.totalTax ||
                          Number(
                            (
                              totalInUsd -
                              (shippingCost + finalFulfillmentCost)
                            ).toFixed(2)
                          ),
                      })
                    );
                  }}
                >
                  Send Invoice
                </SendInvoice>
                <SendInvoice onClick={async () => setOrderTrackingModal(true)}>
                  Order Shipped
                </SendInvoice>
                <SendInvoice onClick={() => setPrintOrderSummaryModal(true)}>
                  Print Order Summary
                </SendInvoice>
                <SendInvoice onClick={sendOrderToPlant}>
                  Send To {printProvider === "CA" ? "US" : "CA"} Plant
                </SendInvoice>
              </OrderSummary>
            </div>
          ) : (
            <div style={{ paddingRight: 10 }}>
              <OrderPushedButton onClick={() => setOrderSubmitToProd(true)}>
                Push Order To Production
              </OrderPushedButton>
            </div>
          )}
        </Wrapper>
      </Container>
      {orderSubmitToProdModal && (
        <OrderSubmitToProd
          order={order}
          open={orderSubmitToProdModal}
          setModal={(v) => setOrderSubmitToProd(v)}
          hideAllModal={() => {
            setOrderSubmitToProd(false);
            setModal(false);
          }}
        />
      )}

      {orderTrackingModal && (
        <UpdateOrderTracking
          order={order}
          open={orderTrackingModal}
          setModal={(v) => setOrderTrackingModal(v)}
          hideAllModal={() => {
            setOrderTrackingModal(false);
            setModal(false);
          }}
        />
      )}

      {browseLibrary && (
        <BrowseLibrary
          viewOnly={true}
          email={user?.email}
          orderLine={order}
          onDrop={(artwork) => {
            window.open(artwork?.secure_url);
          }}
          open={browseLibrary}
          toggle={() => {
            setBrowseLibrary(false);
          }}
        />
      )}
      {printOrderSummaryModal && (
        <PrintOrderSummaryModal
          order={order}
          modal={printOrderSummaryModal}
          setModal={() => setPrintOrderSummaryModal(undefined)}
        />
      )}
    </Dialog>
  );
};

export default OrderModal;
